import React from "react";
import { SwipeableDrawer } from "@material-ui/core";
import "./layout.css";
import Avatar from "../../assets/img/dashboard_avatar.png";
import homeIcon from "../../assets/img/homeIcon.svg";
import scheduleIcon from "../../assets/img/scheduleIcon.svg";
import solutionsIcon from "../../assets/img/solutionsIcon.svg";
import MyProfileImg from "../../assets/img/my_profile.svg";
import ChangePWImg from "../../assets/img/change_pw.svg";
import HelpSupportImg from "../../assets/img/help_support.svg";
import LogoutImg from "../../assets/img/logout.svg";
import Api from "../../common/Api";
import ApiUrl from "../../common/ApiUrl";
import { Link, useHistory } from "react-router-dom";
import lockedImg from "../../assets/img/lockedImg.svg";
import { segmentEvents, restrictedSchoolAssocIds } from "../../utils/constants";
// Import React Icons
import { FaCommentAlt, FaClipboardList, FaFileAlt, FaChartLine } from 'react-icons/fa';

const Sidedrawer = ({ openSidebar, onClose, handleModalOpen, courses, studentData, isFree }) => {
	const [selectedIndex, setSelectedIndex] = React.useState(0);
	const history = useHistory();
	const isRestricted = restrictedSchoolAssocIds.includes(String(studentData.school_assoc.id));

	React.useEffect(() => {
		if (courses.length > 0) setSelectedIndex(courses.findIndex((c) => c.is_enable));
	}, [courses]);

	const onChange = (i) => {
			onClose();
			const formdata = new FormData();
			formdata.append("student_id", studentData.id);
			formdata.append("student_course_id", i);
			Api.doUpload("POST", formdata, ApiUrl.SWITCH_COURSE)
				.then((response) => {
					if (response.status) {
						history.push({
							pathname: "/student",
						});
						document.location.reload();
					} else {
						alert(response.message);
					}
				})
				.catch(() => {
					this.props.history.push("/error");
				});
		
	};

	const handleGoogleFormsClick = () => {
		const baseUrl = "https://docs.google.com/forms/d/e/1FAIpQLSfyGVuHYG_hVtod4nnl8tckrvZVsAUWVDXd92mGt4fWdx0U_Q/viewform";
		const params = new URLSearchParams();
		params.append('usp', 'pp_url');
		
		if (studentData?.name) {
			params.append('entry.674526450', studentData.name);
		}
		if (studentData?.id) {
			params.append('entry.2037984047', studentData.id);
		}
		
		const fullUrl = `${baseUrl}?${params.toString()}`;
		window.open(fullUrl, '_blank');
		onClose();
	};

	const handleOrientationFormClick = () => {
		const baseUrl = "https://docs.google.com/forms/d/e/1FAIpQLSfmyxfrIRzqIGSdMOEfk0o0Nw0cQ2bRVWmII8nO4ifl0cDWaQ/viewform";
		const params = new URLSearchParams();
		params.append('usp', 'pp_url');
		
		if (studentData?.name) {
			params.append('entry.1782462328', studentData.name);
		}
		if (studentData?.id) {
			params.append('entry.753121492', studentData.id);
		}
		if (studentData?.mobile_number) {
			params.append('entry.585425092', studentData.mobile_number);
		}
		
		const fullUrl = `${baseUrl}?${params.toString()}`;
		window.open(fullUrl, '_blank');
		onClose();
	};

	return (
		<>
			<SwipeableDrawer
				PaperProps={{
					style: { borderRadius: "0px 16px 16px 0px" },
				}}
				anchor={"left"}
				open={openSidebar}
				onOpen={() => {}}
				onClose={onClose}>
				<div
					style={{
						width: "80vw",
						maxWidth: 400,
					}}
					className="hamburger-padding paper-stylingg">
					<div>
						<div className="user-details-ham">
							<img
								src={studentData.profile_pic ? studentData.profile_pic : Avatar}
								className="user-avatar-image"
								alt="user_default"
							/>
							<div>
								<div className="userName">{studentData.name}</div>
								<div className="userNumber">+91-{studentData.mobile_number}</div>
							</div>
						</div>
						<hr />
						{!isFree && (
							<div>
								<div className="flexBetween">
									<div className="courseHeading">Current Batch</div>

									{courses.length > 2 && (
										<div className="seeAllCourse" onClick={handleModalOpen}>
											See all
										</div>
									)}
								</div>

								<div className="batchList">
									{courses.slice(0, 2)
									.filter(item => !item.section_name.includes('JCF_') && !item.section_name.includes('M.A.T_'))
									.map((item, i) => {
										return (
											<label className="containerBox" key={i}
											onClick={() => onChange(item.student_course_id)}
											>
												{item.section_name}
												<text
													checked={i === selectedIndex}
													// onChange={() => onChange(i)}
													type="text"
													// name="radio"
												/>
												<span className="checkmark"></span>
											</label>
										);
									})}
								</div>
								<hr />
							</div>
						)}

						<div className="navigationLinks">
							<Link to="/student" className="linkItem" onClick={onClose}>
								<img src={homeIcon} alt="" />
								Home
							</Link>
							{!isRestricted && (isFree ? (
								<div className="linkItem" onClick={() => Api.trackEvent(segmentEvents.NAVBAR.SCHEDULE_CLICK)}>
									<img src={scheduleIcon} alt="" />
									Schedule
									<img src={lockedImg} style={{ width: 14, position: "absolute", right: 0 }} alt="" />
								</div>
							) : (
								<Link to="/student/myschedule" className="linkItem" onClick={() => Api.trackEvent(segmentEvents.NAVBAR.SCHEDULE_CLICK)}>
									<img src={scheduleIcon} alt="" />
									Schedule
								</Link>
							))}
							{!isRestricted && (isFree ? (
								<div
									className="linkItem"
									onClick={() => Api.trackEvent(segmentEvents.NAVBAR.SOLUTIONS_CLICK)}
								>
									<img src={solutionsIcon} alt="" />
									Solution
									<img src={lockedImg} style={{ width: 14, position: "absolute", right: 0 }} alt="" />
								</div>
							) : (
								<Link
									to="/student/doubtmodule/searchquestion"
									className="linkItem"
									onClick={() => Api.trackEvent(segmentEvents.NAVBAR.SOLUTIONS_CLICK)}
								>
									<img src={solutionsIcon} alt="" />
									Solution
								</Link>
							))}
							<Link to="/student/progress" className="linkItem" onClick={onClose}>
								<FaChartLine style={{ fontSize: 20, marginRight: 12 }} />
								My Progress
							</Link>
							<Link to="/student/profile" className="linkItem" onClick={() => Api.trackEvent(segmentEvents.NAVBAR.PROFILE_CLICK)}>
								<img alt="" src={MyProfileImg} />
								My Profile
							</Link>
							<Link to="/student/changepassword" className="linkItem" onClick= {() => Api.trackEvent(segmentEvents.NAVBAR.CHANGEPASSWORD_CLICK)}>
								<img alt="" src={ChangePWImg} />
								Change Password
							</Link>
							<Link to="/student/help-and-support" className="linkItem" onClick= {() => Api.trackEvent(segmentEvents.NAVBAR.HELPSUPPORT_CLICK)}>
								<img alt="" src={HelpSupportImg} />
								Help & Support
							</Link>

							{!isRestricted && (
								<Link to="/student/feedback" className="linkItem" onClick={onClose}>
									<FaClipboardList style={{ fontSize: 20, marginRight: 12 }} />
									Faculty Feedback
								</Link>
							)}

							{/* Add Orientation Form Button */}
							{/* <div className="linkItem" onClick={handleOrientationFormClick}>
								<FaClipboardList style={{ fontSize: 20, marginRight: 0 }} />
								Orientation for Engineering Aspirants
							</div> */}
						</div>
					</div>

					<div 
						className="linkItem" 
						onClick={() => {
							Api.trackEvent(segmentEvents.NAVBAR.LOGOUT_CLICK);
							Api.logout();
						}}
					>
						<img src={LogoutImg} alt="" className="logoutHamImage" />
						Logout
					</div>
				</div>
			</SwipeableDrawer>
		</>
	);
};

export default Sidedrawer;
